import React, { Component } from 'react';
import Header from './Layout/Header';
import RoomTable from './RoomCommon/RoomTable';
import { connect } from 'react-redux';
import { RoomBookingData, CheckLoader } from '../Redux/action/roomAction';
import RoomBookingFilter from './RoomCommon/RoomBookingFilter';
import { onCityLocation1 } from '../Redux/action/memberAction';
import RoomShort from './RoomCommon/RoomShort';
import { dataUser, dataLocation } from './Helpers/util';
import { CSVLink } from 'react-csv';
import { Navigate } from 'react-router-dom';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import CreateRoomBooking from './RoomCommon/createRoomBooking';
import Sidebar from '../Component/Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import { Layout } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import SwButton from './Common/SwButtons/SwButtons';
import SwKpiGroup from './Common/SwKPI/SwKpiGroup';
import SwKpi from './Common/SwKPI/SwKPI';
import SwLoader from './Common/SwLoader/SwLoader';
import SwSelect from './Common/SwReactSelect/SwReactSelect';

var FormData = require('form-data');

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

class RoomBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditHourData: null,
      creditLocation: null,
      RoomList: [],
      RoomData: [],
      locationSpoc: [],
      total: null,
      filterData: {},
      SortData: {},
      company_id: UserObj ? UserObj.company_id : null,
      row: '25',

      pgno: 1,
      isSearchVisible: false,
      searchText: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      accessServiceLists: [],
      loaderServiceAccess: true,
      spinner: true,

      // userRole: (UserObj && UserObj.role_data) ? UserObj.role_data : [],
      userRole: [], 

      collapsed: true,
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
  }

  shortSelectData = shortallkey => {
    this.setState({
      SortData: shortallkey,
    });
  };

  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };
  handleFilterChange = langValue => {
    this.setState({
      filterData: langValue,
    });
  };

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  // chnageSelectMembers = e => {
  //   const formData = new FormData();
  //   formData.append('company_id', this.state.company_id);
  //   formData.append('pgno', this.state.pgno);
  //   formData.append('rtype', e.target.value);
  //   this.props.CheckLoader();
  //   const param = {
  //     company_id: this.state.company_id,
  //     pgno: this.state.pgno,
  //     rtype: e.target.value,
  //     location: [50,93,94,40]
  //   };

  // };

  setUserList = () => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    const param = {
      pgno: this.state.pgno,
      row: this.state.row,
      propertyId: this.state.locationSpoc?.map(item => item.newId),
      clientId: newCompanyId.organizationId,
      type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
      ...this.state.filterData,
      ...this.state.SortData,
    };

    this.props.RoomBookingData(param);
  };

  locationData1 = async () => {
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));

      const axiosConfig = {
        params: {
          spoc: UserObj.rec_id,
          client: this.state.company_id,
        },
      };

      const response = await axiosInstance.get(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/basic-data/get-location-by-spoc`,
        axiosConfig,
      );

      if (response.data.status === 'success' && response.data.data.length > 0) {
        const locations = response.data.data;
        const firstLocation = locations[0];
        const creditLocation = firstLocation
          ? {
              value: firstLocation.rec_id,
              label: firstLocation.location_name,
            }
          : null;
        this.setState({ locationSpoc: locations, creditLocation }, () => {
          // Ensure setUserList is called after locationSpoc is set
          this.setUserList();
          // Fetch credit hours for the default (0-index) location
          this.creditHourData(creditLocation && creditLocation.value);
        });
      } else {
        this.setState({ locationSpoc: [], creditLocation: null, creditHourData: null });
      }
    } catch (error) {
      console.error(error); // Handle errors
    }
  };

  creditHourData = async (locationId = this.state.creditLocation?.value) => {
  const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    try {
      if (!locationId) {
        this.setState({ creditHourData: null });
        return;
      }
      const axiosConfig = {
        params: {
        clientId: newCompanyId.organizationId,
          locationId: locationId,
        },
      };

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL}meeting-room/api/booking/v2/get/credit-hours`,
        axiosConfig
      );
  
      const data = response?.data?.data;
      if (
        response?.data?.status === 200 &&
        typeof data?.freeHour === "number" &&
        typeof data?.usedHour === "number"
      ) {
        this.setState({ creditHourData: data });
      } else {
        this.setState({ creditHourData: null }); // No data or invalid structure
      }
    } catch (error) {
      console.error("Error fetching credit hour data:", error);
      this.setState({ creditHourData: null }); // API failed
    }
  };

  handleCreditLocationChange = selectedOption => {
    this.setState({ creditLocation: selectedOption }, () => {
      this.creditHourData(selectedOption && selectedOption.value);
    });
  };

  async componentDidMount() {

    const userDataLocal = dataUser(); // Fetch user data

    if (userDataLocal) {
      try {
        const UserObj = JSON.parse(userDataLocal);
        this.setState({
          userRole: UserObj.role_data || [], // Ensure it's always an array
        });
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
    try {
      await this.locationData1(); // populates locationSpoc + fetches credit hours for default location
      this.props.onCityLocation1({
        location: [50, 93, 94, 40], // Example data
      });
    } catch (error) {
      console.error('Error in componentDidMount:', error);
    }
  }

  forwordPage(e) {
    e.preventDefault();
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    this.setState(prevState => {
      const newPage = prevState.pgno + 1;

      const param = {
        pgno: newPage,
        row: prevState.row,
        propertyId: prevState.locationSpoc?.map(item => item.newId),
        type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
        clientId: newCompanyId.organizationId,
        ...prevState.filterData,
        ...prevState.SortData,
        pgno: newPage,
      };

      this.props.CheckLoader();
      this.props.RoomBookingData(param);

      return {
        pgno: newPage,
        filterData: { ...prevState.filterData, pgno: newPage },
        SortData: { ...prevState.SortData, pgno: newPage },
      };
    });
  }

  pageBackword(e) {
    e.preventDefault();
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));

    this.setState(prevState => {
      const newPage = Math.max(prevState.pgno - 1, 1); // ✅ Prevent going below 1
      const param = {
        pgno: newPage,
        row: prevState.row,
        propertyId: prevState.locationSpoc?.map(item => item.newId),
        type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
        clientId: newCompanyId.organizationId,
        ...prevState.filterData, // ✅ Persist filters
        ...prevState.SortData,
        pgno: newPage,
      };

      this.props.CheckLoader();
      this.props.RoomBookingData(param);

      return {
        pgno: newPage,

        filterData: { ...prevState.filterData, pgno: newPage },

        SortData: { ...prevState.SortData, pgno: newPage },
      };
    });
  }
  selectRows = e => {
    const newCompanyId = JSON.parse(localStorage.getItem('headData'));
    const newRowValue = e.target.value;

    this.setState(prevState => {
      const param = {
        pgno: prevState.pgno, // Keep the current page number
        row: newRowValue, // Update rows per page
        propertyId: prevState.locationSpoc?.map(item => item.newId), // Keep selected locations
        type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
        clientId: newCompanyId.organizationId,
        ...prevState.filterData, // Keep existing filters
        ...prevState.SortData, // Keep sorting order
      };

      this.props.CheckLoader();
      this.props.RoomBookingData(param);

      return {
        row: newRowValue, // Update state with new row count
        filterData: { ...prevState.filterData, row: newRowValue },
        SortData: { ...prevState.SortData, row: newRowValue },
      };
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  componentWillReceiveProps(props) {
    if (
      props.roomReducer.RoomtList &&
      props.roomReducer.RoomtList.status == 200
    ) {
      this.setState({
        RoomData:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data,

        RoomList:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data &&
          props.roomReducer.RoomtList.data.data.list,
        total:
          props.roomReducer.RoomtList &&
          props.roomReducer.RoomtList.data &&
          props.roomReducer.RoomtList.data.data &&
          props.roomReducer.RoomtList.data.data.count,
      });
      this.setState({
        spinner: false,
      });
    }
  }

  render() {
    const total = this.state.RoomData.count;



const { userRole } = this.state;

    const RoomBooking = this.state.userRole.find(
      element =>
        element.service_id == '16' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );

  
   if (userRole.length > 0 && !RoomBooking) {
      return <Navigate to="/Dashboard" />;
    }




    const roomReducer = this.props.roomReducer;
    const Loader = this.props.roomLoader.loader;

    let letLoader = this.props.roomReducer;
    let alldata =
      letLoader &&
      letLoader.RoomtList &&
      letLoader.RoomtList.data &&
      letLoader.RoomtList.data.data &&
      letLoader.RoomtList.data.data.list !== undefined
        ? letLoader.RoomtList.data.data.list
        : [];
    const getStatus = status => {
      if (status == 1) {
        return 'Booked';
      } else if (status == 2) {
        return 'Ended';
      } else if (status == 3) {
        return 'Shared';
      } else if (status == 4) {
        return 'Cancelled';
      } else {
        return 'Unused Booking';
      }
    };
    var arr2 = alldata.map(v => ({
      roomName: v.roomname,
      roomCategory: v.category,
      roomType: v.room_type == '1' ? 'Meeting Room' : 'Training Room',
      location: v.building_name,
      username: v.first_name + ' ' + v.last_name,
      email: v.email,
      end_time: v.end_time,
      phone: v.phone,
      bookingDate: v.meeting_date,
      startTime: v.start_time,
      endTime: v.end_time,
      amount: v.amount,
      status: getStatus(v.status),
    }));

    const headers = [
      { label: 'Room Name', key: 'roomName' },
      { label: 'Room Category', key: 'roomCategory' },
      { label: 'Room Type', key: 'roomType' },
      { label: 'Location', key: 'location' },
      { label: 'User Type', key: 'username' },
      { label: 'Email', key: 'email' },
      { label: 'Phone Number', key: 'phone' },
      { label: 'Meetinng Date', key: 'bookingDate' },
      { label: 'Booking start Time', key: 'startTime' },
      { label: 'Booking End Time', key: 'endTime' },
      { label: 'Amount ', key: 'amount' },
      { label: 'Status', key: 'status' },
    ];

    let serviceAccess = true;
    const serviceAccessId = 16;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    const createRoomData = this.state.userRole.find(
      element => element.service_id == '29',
    );

    return (
      <>
        <Layout>
          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader
            collapsed={this.state.collapsed}
            toggleCollapsed={this.toggleCollapsed}
          />

          <CreateRoomBooking
show={this.state.showCreateRoomCanvas}
  onClose={() => this.setState({ showCreateRoomCanvas: false })}
  refreshList={this.setUserList}
  refreshCreditHours={() => this.creditHourData()}
          />

          <Layout
            className={
              this.state.collapsed
                ? 'PageLayout CollapsedPageLayout'
                : 'PageLayout'
            }
          >
            {!this.state.spinner ? (
              <div>
                {serviceAccess === true ? (
                  <>
                    <div className="PageContent">
                      <div className="row">
                        <div className="col-md-12 col-lg-6">
                          <div className='SwHeading'>
                            <h2>Room Booking</h2>
                          </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                          <div className="PageHead_Optons_Row mb-2">
                            <ul className='PageHead_Optons_RightAligned'>
                              <li>
                                <RoomBookingFilter
                                  clearSearch={this.clearSearchBox}
                                  namePg={this.state.pgno}
                                  row={this.state.row}
                                  onSelectLanguage={this.handleFilterChange}
                                  show={this.state.showFilterCanvas}
                                  onOpen={() => this.setState({ showFilterCanvas: true })}
                                  onClose={() => this.setState({ showFilterCanvas: false })}
                                />
                              </li>
                              <li>
                                <RoomShort
                                  pageName={this.state.pgno}
                                  row={this.state.row}
                                  setPage={this.setPage}
                                  changeshort={this.shortSelectData}
                                  total={this.state.total}
                                  propertyId={this.state.locationSpoc?.map(
                                    item => item.newId,
                                  )}
                                />
                              </li>
                              
                              <li>
                                <SwButton
                                  size='sm'
                                  onClick={() => this.setState({ showCreateRoomCanvas: true })}
                                >
                                  Create Room Booking
                                </SwButton>
                              </li>
                             
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <SwKpiGroup>
                            <div className="SwKpiBox CreditHoursKpi">
                              <div className="CreditHoursKpi-Location">
                                <i className="bi bi-geo-alt CreditHoursKpi-LocationIcon" />
                                <SwSelect
                                  placeholder="Select Location"
                                  isClearable={false}
                                  value={this.state.creditLocation}
                                  onChange={this.handleCreditLocationChange}
                                  menuPortalTarget={document.body}
                                  menuPosition="fixed"
                                  classNamePrefix="CreditHoursSelect"
                                  options={this.state.locationSpoc?.map(item => ({
                                    value: item.rec_id,
                                    label: item.location_name,
                                  }))}
                                />
                              </div>
                              <div className="CreditHoursKpi-Value">
                                <p className="KpiText mb-0">
                                  Free Credit Hrs./ Used Hrs.
                                </p>
                                <h3 className="KpiNumber mb-0">
                                  {this.state.creditHourData &&
                                  typeof this.state.creditHourData.freeHour ===
                                    'number' &&
                                  typeof this.state.creditHourData.usedHour ===
                                    'number'
                                    ? `${this.state.creditHourData.freeHour} / ${
                                        this.state.creditHourData.usedHour
                                      }`
                                    : '-'}
                                  {this.state.creditHourData?.creditApplicable !=
                                    null && (
                                    <span className="KpiSubNumber">
                                      {' '}
                                      ({this.state.creditHourData.creditApplicable})
                                    </span>
                                  )}
                                </h3>
                              </div>
                            </div>
                            <SwKpi
                            label='Total Bookings'
            value={this.state.RoomData.count}
                            />
                          </SwKpiGroup>
                          <div className="mainAllTable">
                            <div
                              className={
                                Loader == true ? 'loader disable' : 'loader'
                              }
                            >
                              <img
                                className=""
                                src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                                alt="Loder"
                              />
                            </div>
                            <RoomTable
                              propertyId={this.state.locationSpoc?.map(
                                item => item.newId,
                              )}
                              pgno={this.state.pgno}
                              row={this.state.row}
                              filterData={this.state.filterData}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : this.state.loaderServiceAccess == true ? (
                  <>
                    <div className="loader">
                      <img
                        className=""
                        src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                        alt="Loder"
                      />
                    </div>
                  </>
                ) : (
                  <MarketingPanel />
                )}
              </div>
            ) : (
              <SwLoader />
            )}
          </Layout>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  roomReducer: state.roomReducer,
  roomLoader: state.roomReducer,
});

const mapActionsToProps = {
  RoomBookingData,
  CheckLoader,
  onCityLocation1,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(RoomBooking);
